<template>
  <soha-page-loading v-if="loading" />
  <div v-else class="card card-custom gutter-b px-4 px-8 pt-8 pb-0">
    <soha-no-access
      v-if="!access"
      :message="$t(`${I18nPrefix}ACCESS_MESSAGE`)"
    />
    <div v-else>
      <div class="mb-3">
        <span class="soha-page-title">
          {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
        </span>
      </div>
      <soha-no-data
        v-if="!invoices.length"
        :message="$t(`${I18nPrefix}NO_DATA`)"
      />
      <div class="row mx-0">
        <soha-page-loading class="mx-auto" v-if="paginateLoading" />
        <div
          class="col-6 mb-4"
          v-for="invoice in invoices"
          :key="invoice.id"
          v-else
        >
          <router-link
            class="row mx-0 soha-invoice-card"
            :class="invoice.statusId == 1 ? 'paid-card' : 'unpaid-card'"
            :to="{ name: 'invoice-detail', query: { id: invoice.id } }"
          >
            <div class="col-6">
              <div
                class="py-3 d-flex justify-content-between align-items-center"
              >
                <span>
                  {{ $t(`${I18nPrefix}TYPE`) }}
                </span>
                <span class="font-weight-bolder text-center primary-color mt-2">
                  {{ invoice.payFor }}
                </span>
              </div>
              <div
                class="py-3 d-flex justify-content-between align-items-center"
              >
                <span>
                  {{ $t(`${I18nPrefix}CREATE_AT`) }}
                </span>
                <span class="font-weight-bolder text-center primary-color mt-2">
                  {{ toPersianDigits(invoice.created_at) }}
                </span>
              </div>
              <div
                class="py-3 d-flex justify-content-between align-items-center"
              >
                <span>
                  {{ $t(`${I18nPrefix}AMOUNT_PAYABLE`) }}
                </span>
                <span class="font-weight-bolder text-center primary-color">
                  {{ rialToToman(invoice.amountPayable) }}
                  {{ $t(`${I18nPrefix}TOMAN`) }}
                </span>
              </div>
            </div>
            <div class="col-6 d-flex justify-content-center align-items-center">
              <span
                :class="
                  invoice.statusId == 1
                    ? 'soha-invoice-paid'
                    : 'soha-invoice-unpaid'
                "
              >
                {{ invoice.status }}
              </span>
            </div>
          </router-link>
        </div>
        <div class="col-12 mt-3">
          <b-pagination
            v-if="totalInvoiceCount > perPage"
            v-model="currentPage"
            @input="goToPage"
            :total-rows="totalInvoiceCount"
            :per-page="perPage"
            align="center"
            pills
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
import { mapGetters } from "vuex";
export default {
  name: "invoice",

  mixins: [UIMixin],

  data() {
    return {
      I18nPrefix: "PAGES.FINANCIAL.INVOICE.",
      loading: false,
      paginateLoading: false,
      access: true,
      invoices: [],
      currentPage: this.$route.query.page ?? 1,
      totalInvoiceCount: null,
      perPage: null,
    };
  },

  mounted() {
    this.getInvoices(true);
  },

  methods: {
    getInvoices(loading) {
      this.loading = loading;
      ApiService.get(`api/v2/invoices`, {
        page: this.currentPage,
        perPage: "10",
      }).then((data) => {
        if (!data.data.code) {
          this.invoices = data.data.data;
          this.totalInvoiceCount = data.data.total;
          this.perPage = +data.data.per_page;
        } else if (data.data.code == 403) {
          this.access = false;
        } else {
          this.errorToast(data.data.message);
        }
        this.loading = false;
        this.paginateLoading = false;
      });
    },

    rialToToman(price) {
      return this.toPersianDigits(Math.round(price / 10).toLocaleString());
    },

    goToPage() {
      this.$router.push({ query: { page: this.currentPage } });
      this.paginateLoading = true;
      this.getInvoices();
    },
  },

  computed: {
    ...mapGetters(["companyId"]),
  },

  watch: {},
};
</script>

<style scoped>
.soha-invoice-card {
  border: 0.077rem solid var(--box-border-color);
  border-radius: 0.385rem;
  position: relative;
  color: inherit;
  padding-right: 0.615rem;
}
.soha-invoice-card:before {
  content: "";
  width: 0.769rem;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-top-right-radius: 0.308rem;
  border-bottom-right-radius: 0.308rem;
}
.soha-invoice-card.unpaid-card:before {
  background-color: var(--tag-dark-red-color);
}
.soha-invoice-card.paid-card:before {
  background-color: var(--tag-dark-green-color);
}
.soha-invoice-paid,
.soha-invoice-unpaid {
  border-radius: 0.385rem;
  padding: 0.385rem 0.769rem;
  min-width: 11.538rem;
  transform: rotate(-30deg);
  text-align: center;
}
.soha-invoice-paid {
  color: var(--tag-dark-green-color);
  border: 0.077rem solid var(--tag-dark-green-color);
}
.soha-invoice-unpaid {
  color: var(--tag-dark-red-color);
  border: 0.077rem solid var(--tag-dark-red-color);
}
</style>
